import FamilyDrama from "../assets/Family-Drama-Int2cruises.png" ;
import Adventure from "../assets/Adventure-Int2cruises.png" ;
import Romance from "../assets/Romance-Int2cruise.png" ;
import Expedition from "../assets/Expedition.png" ;


const Feelingdata = [
    {
        img:FamilyDrama ,
        heading:"Family Drama" ,
        content:"Fun-filled adventures and activities for young explorers.",
        // link:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=1,10,4,982,6,7,8&sortcolumn=price&sortorder=asc"
         links: {
      INR: "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&cruiseline=1,10,4,982,6,7,8&sortcolumn=price&sortorder=asc",
      USD: "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=1,10,4,982,6,7,8&sortcolumn=price&sortorder=asc",
      SGD: "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&cruiseline=1,10,4,982,6,7,8&sortcolumn=price&sortorder=asc"
    }
    },

    {
        img:Adventure ,
        heading:"Adventure" ,
        content:"Memorable experiences for the whole family to enjoy." ,
        // link:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=982,6,7,8&sortcolumn=price&sortorder=asc"
           links: {
      INR: "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&cruiseline=982,6,7,8&sortcolumn=price&sortorder=asc",
      USD: "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=982,6,7,8&sortcolumn=price&sortorder=asc",
      SGD: "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&cruiseline=982,6,7,8&sortcolumn=price&sortorder=asc"
    }
        
    } ,


     {
        img:Romance,
        heading:"Romance" ,
        content:"Intimate escapes and dreamy moments at sea.",
        // link:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=8138,8121,1043,2,8829,8149,8175,8112&sortcolumn=price&sortorder=asc"
           links: {
      INR: "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&cruiseline=8138,8121,1043,2,8829,8149,8175,8112&sortcolumn=price&sortorder=asc",
      USD: "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=8138,8121,1043,2,8829,8149,8175,8112&sortcolumn=price&sortorder=asc",
      SGD: "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&cruiseline=8138,8121,1043,2,8829,8149,8175,8112&sortcolumn=price&sortorder=asc"
    }
        

     },


     {
        img:Expedition,
        heading:"Expedition" ,
        content:"Thrilling activities and bold experiences for the adrenaline-seekers.",
        // link:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=8282,8115&sortcolumn=price&sortorder=asc"
           links: {
      INR: "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&cruiseline=8282,8115&sortcolumn=price&sortorder=asc",
      USD: "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=8282,8115&sortcolumn=price&sortorder=asc",
      SGD: "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&cruiseline=8282,8115&sortcolumn=price&sortorder=asc"
    }
        

     }

]


export default Feelingdata ;